/**
 * Web Vitals plugin: captures CLS/LCP/INP/FCP/TTFB metrics.
 */
import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

import type { PluginContext } from "../lib/types";

import { registerPlugin } from "./register";

type WebVitalsObservers = {
  onCLS: typeof onCLS;
  onFCP: typeof onFCP;
  onINP: typeof onINP;
  onLCP: typeof onLCP;
  onTTFB: typeof onTTFB;
};

const defaultObservers: WebVitalsObservers = {
  onCLS,
  onFCP,
  onINP,
  onLCP,
  onTTFB,
};

export function createWebVitalsPlugin(
  ctx: PluginContext,
  observers: WebVitalsObservers = defaultObservers,
) {
  let generation = 0;

  return {
    onInit() {
      const activeGeneration = ++generation;
      const report = (metric: any) => {
        if (generation !== activeGeneration) return;
        if (!ctx.canTrackCategory("performance_analytics")) return;
        ctx.track("web_vitals", {
          name: metric.name,
          value: metric.value,
          rating: metric.rating,
          id: metric.id,
        });
      };
      observers.onCLS(report);
      observers.onFCP(report);
      observers.onINP(report);
      observers.onLCP(report);
      observers.onTTFB(report);
    },
    onUnload() {
      generation += 1;
    },
  };
}

registerPlugin("webvitals", createWebVitalsPlugin);
